import { Feature } from "ol";
import { AttributeValue } from "./AttributeValue";

/**
 * ファイル出力用属性クラス
 */
export class ExportValue {
  /**
   * JSON出力用Feature
   */
  feature: Feature;

  /**
   * 画面項目リスト
   */
  attributeValues: Array<AttributeValue>;

  /**
   * JSONファイル名
   */
  jsonFileName: string;

  /**
   * CSVファイル名
   */
  csvFileName: string;

  /**
   * @param feature 地物情報
   * @param attributeValues 属性表示値
   * @param jsonFileName JSON出力ファイル名
   * @param csvFileName CSV出力ファイル名
   */
  constructor(
    feature: Feature,
    attributeValues: Array<AttributeValue>,
    jsonFileName: string,
    csvFileName: string
  ) {
    this.feature = feature;
    this.attributeValues = attributeValues.map((ele) => {
      if (
        ele.value === null ||
        ele.value === undefined ||
        String(ele.value).replaceAll(" ", "") === ""
      ) {
        ele.value = "-";
      }
      return ele;
    });
    this.jsonFileName = jsonFileName;
    this.csvFileName = csvFileName;
  }
}
